module.exports = __webpack_public_path__ + "static/RR1-71008797cd835b07fd498a19598951e6.jpg";